import { atom, useAtom } from "jotai";

export type ComboState = "instruments" | "prices";

export const comboStateAtom = atom<ComboState>("instruments");

export const useComboState = () => {
  const [comboState, setComboState] = useAtom(comboStateAtom);

  return {
    comboState,
    setComboState,
  };
};
